import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IoMdHome } from "react-icons/io";
import { AiOutlineDiff } from "react-icons/ai";
import { GiGraduateCap } from "react-icons/gi";
import { TbReportAnalytics } from "react-icons/tb";
import { IoMdContact } from "react-icons/io";
import { HiMenu, HiX } from "react-icons/hi";
import LOGO from "../assets/img/p.png";
import { useAuth } from "../../AuthContext";

const Header = () => {
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="bg-[#0F2A44] border-b border-black w-full text-white">

      {/* Top Bar */}
      <div className="flex justify-between items-center h-[80px] px-4 lg:px-6 max-w-7xl mx-auto">

        {/* Logo Section */}
        <div className="flex items-center gap-3">
          <img
            src={LOGO}
            alt="Logo"
            className="h-[50px] w-[50px] lg:h-[65px] lg:w-[65px] rounded-full object-cover"
          />
          <h1 className="font-bold text-xl sm:text-2xl lg:text-3xl">
            PSYCHEMETRICS
          </h1>
        </div>

        {/* Desktop Menu */}
        <div className="hidden lg:flex gap-6 items-center text-lg">

          <Link className="flex items-center gap-2 hover:text-gray-300" to="/home">
            <IoMdHome className="text-xl" />
            Home
          </Link>

          <Link className="flex items-center gap-2 hover:text-gray-300" to="/tests">
            <AiOutlineDiff className="text-xl" />
            Tests
          </Link>

          <Link className="flex items-center gap-2 hover:text-gray-300" to="/results">
            <TbReportAnalytics className="text-xl" />
            Results
          </Link>

          {user && (
            <Link className="flex items-center gap-2 hover:text-gray-300" to="/create">
              <GiGraduateCap className="text-xl" />
              Create
            </Link>
          )}

          <Link className="flex items-center gap-2 hover:text-gray-300" to="/about">
            <IoMdContact className="text-xl" />
            About
          </Link>

        </div>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden text-3xl"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-[#0F2A44] border-t border-gray-700 px-6 pb-4 flex flex-col gap-4 text-lg">

          <Link
            className="flex items-center gap-3"
            to="/home"
            onClick={() => setMenuOpen(false)}
          >
            <IoMdHome /> Home
          </Link>

          <Link
            className="flex items-center gap-3"
            to="/tests"
            onClick={() => setMenuOpen(false)}
          >
            <AiOutlineDiff /> Tests
          </Link>

          <Link
            className="flex items-center gap-3"
            to="/results"
            onClick={() => setMenuOpen(false)}
          >
            <TbReportAnalytics /> Results
          </Link>

          {user && (
            <Link
              className="flex items-center gap-3"
              to="/create"
              onClick={() => setMenuOpen(false)}
            >
              <GiGraduateCap /> Create Test
            </Link>
          )}

          <Link
            className="flex items-center gap-3"
            to="/about"
            onClick={() => setMenuOpen(false)}
          >
            <IoMdContact /> About
          </Link>

        </div>
      )}
    </div>
  );
};

export default Header;